(function () {
  var switched = false;

  function findInputForLabel(label) {
    var input = null;
    var forAttr = label.getAttribute('for');
    if (forAttr) {
      input = document.getElementById(forAttr);
    }
    if (!input) {
      input = label.querySelector('input');
    }
    if (!input && label.previousElementSibling && label.previousElementSibling.tagName === 'INPUT') {
      input = label.previousElementSibling;
    }
    if (!input && label.nextElementSibling && label.nextElementSibling.tagName === 'INPUT') {
      input = label.nextElementSibling;
    }
    return input;
  }

  function findNextLabelInDOM(element) {
    var sibling = element.nextElementSibling;
    while (sibling) {
      if (sibling.tagName === 'LABEL' && sibling.textContent.indexOf('1週間') === -1) {
        return sibling;
      }
      var nested = sibling.querySelector && sibling.querySelector('label');
      if (nested && nested.textContent.indexOf('1週間') === -1) {
        return nested;
      }
      sibling = sibling.nextElementSibling;
    }

    var parent = element.parentElement;
    if (parent) {
      var parentSibling = parent.nextElementSibling;
      while (parentSibling) {
        if (parentSibling.tagName === 'LABEL' && parentSibling.textContent.indexOf('1週間') === -1) {
          return parentSibling;
        }
        var nested = parentSibling.querySelector && parentSibling.querySelector('label');
        if (nested && nested.textContent.indexOf('1週間') === -1) {
          return nested;
        }
        parentSibling = parentSibling.nextElementSibling;
      }
    }
    return null;
  }

  function hideOneWeekOptions() {
    var containers = document.querySelectorAll('.sc-fotPbf');
    containers.forEach(function (container) {
      var labels = container.querySelectorAll('label');
      var firstWeekLabel = null;

      labels.forEach(function (label) {
        if (label.textContent.indexOf('1週間') === -1) return;

        if (!firstWeekLabel) {
          firstWeekLabel = label;
        }

        label.style.display = 'none';

        var input = findInputForLabel(label);
        if (input) {
          input.style.display = 'none';
        }
      });

      if (firstWeekLabel && !switched) {
        switched = true;
        var nextLabel = findNextLabelInDOM(firstWeekLabel);
        if (!nextLabel && firstWeekLabel.parentElement) {
          nextLabel = findNextLabelInDOM(firstWeekLabel.parentElement);
        }
        if (nextLabel) {
          nextLabel.click();
        }
      }
    });
  }

  var observer = new MutationObserver(function () {
    hideOneWeekOptions();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', hideOneWeekOptions);
})();
